<template>

	<v-menu bottom offset-y content-class="menuContainer">
		<template v-slot:activator="{ on, attrs }">
			<span v-bind="attrs" v-on="on" class="material-icons iconSize24 menuButton">menu</span>
		</template>
		<div class="menuGroup">
			<div class="menuItem d-flex align-center">
				<span class="material-icons iconSize24">language</span>
				{{ $t("menu.language") }}
			</div>
			<div class="subMenu">
				<div v-for="(lang, i) in languages" :key="'lang' + i" class="subMenuItem d-flex align-center text-left text-no-wrap" @click="onSelect(lang)">
					<span v-if="lang == currentLanguage" class="material-icons iconSize24 itemIcon">check</span>
					<img :src="require('@/assets/Flag_' + lang + '.png')" :alt="'flag_' + lang" class="languageImage" :class="{ indented: lang != currentLanguage }" />
					{{ $t("language." + lang) }}
				</div>
			</div>
		</div>
	</v-menu>

</template>

<script>
import Logger from '@/assets/scripts/logger.js'
import $ from 'jquery'

export default {
	name: "MainMenu",
	data() {
		return {
			currentLanguage: this.$i18n.locale,
			languages: this.$i18n.availableLocales
		}
	},
	beforeCreate() {
		Logger.log("MainMenu.vue beforeCreate");
	},
	created() {
		Logger.log("MainMenu.vue created");
	},
	beforeMount() {
		Logger.log("MainMenu.vue beforeMount");
	},
	mounted() {
		Logger.log("MainMenu.vue mounted");
	},
	beforeUpdate() {
		Logger.log("MainMenu.vue beforeUpdate");
	},
	updated() {
		Logger.log("MainMenu.vue updated");
	},
	beforeDestroy() {
		Logger.log("MainMenu.vue beforeDestroy");
	},
	destroyed() {
		Logger.log("MainMenu.vue destroyed");
	},
	methods: {
		onSelect(lang) {
			this.$i18n.locale = this.currentLanguage = lang;

			// set window title
			var title;
			if (this.$root.lessonData.category) {
				title = this.$root.lessonData.category[lang] || this.$root.lessonData.category["en"];
			}
			document.title = title || this.$t("windowTitle");

			// update video player tooltips and menu titles
			if (this.$root.lessonData.isVideoLesson) {
				$("#divVideoPlayer").videoPlayer("updateTitles", {
					textSpeedMenu : this.$t("videoPlayer.speedMenu"),
					textSubtitleLabels : this.mxnSubtitleMenuLabels(),
					titleChaptersButton : this.$t("videoPlayer.chaptersBtn"),
					titleCloseAnnotationButton : this.$t("videoPlayer.closeAnnotationBtn"),
					titleExitFullscreenButton : this.$t("videoPlayer.exitFullscreenBtn"),
					titleFullscreenButton : this.$t("videoPlayer.fullscreenBtn"),
					titleMuteButton : this.$t("videoPlayer.muteBtn"),
					titlePauseButton : this.$t("videoPlayer.pauseBtn"),
					titlePlayButton : this.$t("videoPlayer.playBtn"),
					titleReplayButton : this.$t("videoPlayer.replayBtn"),
					titleResolutionButton : this.$t("videoPlayer.resolutionBtn"),
					titleResolutionMenu : this.$t("videoPlayer.titleResolutionMenu"),
					titleRestartButton : this.$t("videoPlayer.restartBtn"),
					titleSpeedButton : this.$t("videoPlayer.speedBtn"),
					titleSubtitlesButton : this.$t("videoPlayer.subtitlesBtn"),
					titleUnmuteButton : this.$t("videoPlayer.unmuteBtn")
				});
			}
		}
	}
}
</script>

<style lang="scss" scoped>

	@import '@/assets/scss/_definitions.scss';

	.menuButton {
		color: $globColSec;
		cursor: pointer;
		font-weight: 400;

		&:hover {
			color: $globColPrim;
		}
	}

	.menuContainer {
		background-color: #fff;
		contain: initial;
		margin-top: 0.5rem;
		overflow: visible;
		padding: 0 0.25rem;
	}

	.menuContainer::before {
		position: absolute;
		content: "";
		top: -0.5rem;
		right: 0.75rem;
		width: 0;
		height: 0;
		border-style: solid;
		border-width: 0 0.5rem 0.5rem;
		border-color: transparent transparent #fff;
	}

	.menuGroup {
		border-top: 1px solid rgba(148, 154, 166, 0.20);
		border-bottom: 1px solid rgba(148, 154, 166, 0.20);

		&:first-child {
			border-top: none;
			margin-top: 0.75rem;
			padding-top: 0;
		}

		&:last-child {
			border-bottom: none;
			padding-bottom: 0;
		}

		.menuItem {
			border-bottom: 1px solid rgba(148, 154, 166, 0.10);
			color: $globColSec;
			font-weight: 400;
			padding: 0.25rem 1rem;

			span {
				margin-right: 0.8rem;
			}
		}

		.subMenuItem {
			padding: 0.1rem 1rem;
			color: $globColSec;
			cursor: pointer;
			font-weight: 400;
			transform: translateY(-2px);
			max-width: 250px;
			overflow: hidden;
			text-overflow: ellipsis;
			white-space: nowrap;

			&:hover {
				color: $globColPrim;
			}

			span {
				margin-right: 0.8rem;
			}

			.indented {
				margin-left: 2.7rem;
			}

			.itemIcon {
				width: 1.9rem;
			}

			.languageImage {
				margin-right: 0.5rem;
				max-height: 2rem;
				max-width: 2rem;
			}
		}
	}

</style>
